import React from 'react';
import styles from '../Services.module.css';

const warningMarkIconUrl = `${process.env.PUBLIC_URL}/icons/warning_mark.svg`;

const ServicesWarningIcon: React.FC = () => {
  const [useInlineFallback, setUseInlineFallback] = React.useState(false);

  return (
    <div className={styles.stateIcon} aria-hidden="true">
      {useInlineFallback ? (
        <svg
          className={styles.stateIconGlyph}
          viewBox="0 0 24 24"
          focusable="false"
          data-testid="services-warning-icon-fallback"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 6v8m.05 4v.1h-.1V18z"
          />
        </svg>
      ) : (
        <img
          className={styles.stateIconGlyph}
          src={warningMarkIconUrl}
          alt=""
          onError={() => setUseInlineFallback(true)}
        />
      )}
    </div>
  );
};

export default ServicesWarningIcon;
